import { createContext } from 'react'

type HeadersContextType = {
  getFullUrl: () => string
  correlationId?: string
  userAgent?: string
}

export const HeadersContext = createContext<HeadersContextType>({
  getFullUrl: () => '',
  correlationId: '',
  userAgent: '',
})

export const HeadersProvider = HeadersContext.Provider
